<script>
    export let name = ""
    export let value = false
    export let items = {}
    
    $: text = items[name].text
</script>


<div class="chip">
    <img src={`items/${name}.png`} alt={text}/> 
    <label>
        <input type="checkbox" bind:checked={value}/><span>{text}</span>
    </label>
</div>


<style>
</style>